import React, { Component } from 'react'
import { MuiGrid, MuiEdit, MuiPaper, MuiTypography, MuiTextField, MuiDeleteIcon, MuiInputBase } from '../../../ui/MaterialUIComponents'
import theme from '../../../../assests/theme'
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import { weekDays } from '../enum'
import lodashUtil from 'lodash';
import { getGradesString } from '../../gradePicker/gradePickerUtil'
import AlertDialogComponent from '../teacher/AlertDialogComponent';


class WeeklyCalendarCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cal: this.props.cal,
      toggle: false,
      openDialog: false
    }
  }

  handeleDeleteCalendar = () => {
    let key = this.props.index
    this.props.removeCalendarFromWeeklyCalendar(key, this.props.weeklyCalendar)
    this.setState({
      toggle: !this.state.toggle
    })

  }

  handleClickOpenDialog = () => {
    this.setState({ openDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleClickOnYes = () => {
    this.setState({ openDialog: false });
    this.handeleDeleteCalendar();
  }
  render() {
    return (<MuiGrid container id='grid' xs={10} direction="row" >

      <MuiGrid container id='grid' xs={12} direction="row" style={{ background: theme.palette.grey.lightest, border: '1px solid ' + theme.palette.grey.dark, padding: "8px" }} >
        <MuiGrid container xs={12} direction="row" justify="flex-end">
          <MuiGrid item xs={1}>
            <MuiEdit id='edit' style={{ color: theme.palette.grey.dark, cursor: 'pointer' }} onClick={() => { this.props.onClickOfEditCalendar(this.props.cal, this.props.calIndex) }} />
          </MuiGrid>

          <MuiGrid item xs={1}>
            <MuiDeleteIcon style={{ color: theme.palette.grey.dark, cursor: 'pointer' }} onClick={() => this.handleClickOpenDialog()} />
          </MuiGrid>
        </MuiGrid>
        {this.state.openDialog ?
          <AlertDialogComponent
            {...this.props}
            openDialog={this.state.openDialog}
            handleCloseDialog={this.handleCloseDialog}
            deleteTeacher={this.props.deleteTeacher}
            handleClickOnYes={this.handleClickOnYes}
          /> : null}
        <MuiGrid container xs={12} style={{ margin: '5px' }} >
          <MuiGrid container xs={12} direction="row" >
            <MuiGrid item xs={5} align='left' style={{}}>
              <MuiTypography gutterBottom style={theme.typography.h7}>Number Of Periods: </MuiTypography>
            </MuiGrid>
            <MuiGrid item xs={4} align='left' >
              <MuiTypography gutterBottom style={theme.typography.body2} >{`${this.props.cal.totalPeriods} - Periods`}</MuiTypography>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={12} direction="row" >
            <MuiGrid item xs={5} align='left'  >
              <MuiTypography gutterBottom style={theme.typography.h7}>Number Of Days:</MuiTypography>
            </MuiGrid>
            <MuiGrid item xs={6} align='left' >
              <MuiTypography gutterBottom style={theme.typography.body2}>{this.props.cal.workingDays}</MuiTypography>
            </MuiGrid>
          </MuiGrid>
          <MuiGrid container xs={12} style={{ height: '5vh' }}>
            <MuiGrid item xs={5} align='left'  >
              <MuiTypography gutterBottom style={theme.typography.h7}
              >Grades:</MuiTypography>
            </MuiGrid>
            <MuiGrid item xs={6} align='left'>
              {this.props.cal.gradeDetails !== undefined &&
                <MuiTypography gutterBottom style={theme.typography.body2}>{getGradesString(this.props.cal.gradeDetails)}</MuiTypography>}
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
      </MuiGrid>


    </MuiGrid>
    )
  }
}
export default WeeklyCalendarCard
